import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export interface BasicTableProps {
    serviceInfo: any;
}

const BasicTable =({
    serviceInfo
}: BasicTableProps) =>{
    const rows = serviceInfo.srv_Time;

    return (
        <TableContainer component={Paper}>
            <Table style={{ border: '0px', borderColor: 'black', borderStyle: 'revert'}}>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ padding: '1px', fontSize: '18px', backgroundColor: '#FCE4EC80'}} align="center">星期</TableCell>
                        <TableCell style={{ padding: '1px', fontSize: '18px', backgroundColor: '#FCE4EC80'}} align="center">一</TableCell>
                        <TableCell style={{ padding: '1px', fontSize: '18px', backgroundColor: '#FCE4EC80'}} align="center">二</TableCell>
                        <TableCell style={{ padding: '1px', fontSize: '18px', backgroundColor: '#FCE4EC80'}} align="center">三</TableCell>
                        <TableCell style={{ padding: '1px', fontSize: '18px', backgroundColor: '#FCE4EC80'}} align="center">四</TableCell>
                        <TableCell style={{ padding: '1px', fontSize: '18px', backgroundColor: '#FCE4EC80'}} align="center">五</TableCell>
                        <TableCell style={{ padding: '1px', fontSize: '18px', backgroundColor: '#FCE4EC80'}} align="center">六</TableCell>
                        <TableCell style={{ padding: '1px', fontSize: '18px', backgroundColor: '#FCE4EC80'}} align="center">日</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, index) => (
                        <TableRow
                            key={index}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell style={{ padding: '1px', paddingTop: '5px', paddingBottom : '5px', fontSize: '18px'}} align="center">
                                {/*0上午,1下午,2晚上 */}
                                {index === 0 ? '上午' : index === 1 ? '下午' : '晚上'}
                            </TableCell>
                            <TableCell style={{ padding: '1px', paddingTop: '5px', paddingBottom : '5px', fontSize: '18px', textAlign: 'center'}} align="center">
                                {row[0].yn === 'Y' ? '休' : '✓'}
                            </TableCell>
                            <TableCell style={{ padding: '1px', paddingTop: '5px', paddingBottom : '5px', fontSize: '18px'}} align="center">
                                {row[1].yn === 'Y' ? '休' : '✓'}
                            </TableCell>
                            <TableCell style={{ padding: '1px', paddingTop: '5px', paddingBottom : '5px', fontSize: '18px'}} align="center">
                                {row[2].yn === 'Y' ? '休' : '✓'}
                            </TableCell>
                            <TableCell style={{ padding: '1px', paddingTop: '5px', paddingBottom : '5px', fontSize: '18px'}} align="center">
                                {row[3].yn === 'Y' ? '休' : '✓'}
                            </TableCell>
                            <TableCell style={{ padding: '1px', paddingTop: '5px', paddingBottom : '5px', fontSize: '18px'}} align="center">
                                {row[4].yn === 'Y' ? '休' : '✓'}
                            </TableCell>
                            <TableCell style={{ padding: '1px', paddingTop: '5px', paddingBottom : '5px', fontSize: '18px'}} align="center">
                                {row[5].yn === 'Y' ? '休' : '✓'}
                            </TableCell>
                            <TableCell style={{ padding: '1px', paddingTop: '5px', paddingBottom : '5px', fontSize: '18px'}} align="center">
                                {row[6].yn === 'Y' ? '休' : '✓'}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default BasicTable;